import {
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";

type ScreenSize = {
  width: number;
  height: number;
};

type ScreenContextType = {
  screenSize: ScreenSize;
  isMobile: boolean;
  orientation: "portrait" | "landscape";
};

const ScreenContext = createContext<ScreenContextType | undefined>(undefined);

export const ScreenProvider = ({ children }: { children: ReactNode }) => {
  const [screenSize, setScreenSize] = useState<ScreenSize>({
    width: 0,
    height: 0,
  });
  const [orientation, setOrientation] = useState<"portrait" | "landscape">(
    "portrait",
  );

  useEffect(() => {
    const updateSize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;

      setScreenSize({ width, height });
      setOrientation(width > height ? "landscape" : "portrait");
    };

    updateSize(); // Executa na montagem

    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const isMobile = screenSize.width <= 960;

  return (
    <ScreenContext.Provider value={{ screenSize, isMobile, orientation }}>
      {children}
    </ScreenContext.Provider>
  );
};

export const useScreen = () => {
  const context = useContext(ScreenContext);
  if (context === undefined) {
    throw new Error("useScreen must be used within a ScreenProvider");
  }
  return context;
};
